import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/GENERAL/iwwportsgeneral";
import TODIS_FORM_DESC from "./form/GENERAL/description";
import TODIS_FORM_TENCOMPLIANCE from "./form/GENERAL/iwwportstencompliance";
import TODIS_FORM_ELEGPROJECT from "./form/GENERAL/iwwportselegibilityproject";
import TODIS_FORM_INDICATORS from "./form/GENERAL/indicators";
import TODIS_FORM_PERFOMANCE_INDICADOR from "./form/GENERAL/perfomanceindicador";
import TODIS_FORM_STATUS from "./form/LIWWPORTS/status";
import { TODIS_FORM_DSC } from "../../components/Forms";
import TODIS_FORM_LIVE_FUND from "./form/LIWWPORTS/lFundingsources";
import TODIS_TECH_DOCU from "./form/LIWWPORTS/lTechnicalDocumentation";
import TODIS_TIMELINE from "./form/GENERAL/lTimeline";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_OTHER_IWWPP from "./form/LIWWPORTS/other";
import { loadModules } from 'esri-loader';

const TODIS_FORM_LIWWPORTS = ({ errors, touched, status, setFieldValue, values }) => {
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)
    useEffect(() => {
        try {
            const [Query, query] = loadModules(["esri/rest/support/Query", "esri/rest/query"]);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/41";

            let queryObject = new Query();
            queryObject.where = `live_iww_ports_proj_id=${values.liveIwwPortsProjId}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            const results = query.executeQueryJSON(queryUrl, queryObject);

            if (results.features.length > 0) {
                setStatusTabDisabled(false);
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }

    })
    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const descriptionTooltip = (
        <Tooltip id="description-tooltip">
            Project description
        </Tooltip>
    )

    const statusTooltip = (
        <Tooltip id="status-tooltip">
            Project implementation status
        </Tooltip>
    )

    const tentIndicatorsTooltip = (
        <Tooltip id="tent-indicators-tooltip">
            The TEN-T indicators the project will be addressing
        </Tooltip>
    )

    const tentComplianceTooltip = (
        <Tooltip id="tent-compliance-tooltip">
            Current compliance of the IWW Port section the project is related to
        </Tooltip>
    )

    const perfIndicatorsTooltip = (
        <Tooltip id = "perfIndicators-tooltip">
            Project's compliance indicators
        </Tooltip >
    )

    const fundSourcesTooltip = (
        <Tooltip id = "fundSources-tooltip">
            Project's funding sources
        </Tooltip>
    )

    const techDocuTooltip = (
        <Tooltip id = "techDocu-tooltip">
            Project's technical documentation
        </Tooltip>
    )

    const otherTootltip = (
        <Tooltip id="other-tooltip">
            Other parameters related data
        </Tooltip>
    );

    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title="General" >
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} TypeForm="" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Description" title="Description">
                <Container>
                    <Row>
                        <TODIS_FORM_DESC errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsLivePmDescDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwPortsLivePmDescDTO.remarks" label="Remarks" name="iwwPortsLivePmDescDTO.remarks" disabled={status} />
                            {errors.iwwPortsLivePmDescDTO && errors.iwwPortsLivePmDescDTO.remarks && touched.iwwPortsLivePmDescDTO && touched.iwwPortsLivePmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwPortsLivePmDescDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="status" title="Status">
                <TODIS_FORM_STATUS errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lFund" title="Funding sources">
                <TODIS_FORM_LIVE_FUND errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTechDocu" title="Technical documentation">
                <TODIS_TECH_DOCU errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTimeline" title="Timeline">
                <TODIS_TIMELINE errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="elegibilityproject" title="Targeted TEN-T indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsLivePmEligiTentDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwPortsLivePmEligiTentDTO.remarks" label="Remarks" name="iwwPortsLivePmEligiTentDTO.remarks" disabled={status} setFieldValue={setFieldValue} values={values} />
                            {errors.iwwPortsLivePmEligiTentDTO && errors.iwwPortsLivePmEligiTentDTO.remarks && touched.iwwPortsLivePmEligiTentDTO && touched.iwwPortsLivePmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwPortsLivePmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="tencompliance" title="TEN-T compliance of the related IWW port">
                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsLivePmTentcompDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwPortsLivePmTentcompDTO.remarks" label="Remarks" name="iwwPortsLivePmTentcompDTO.remarks" disabled={status} />
                            {errors.iwwPortsLivePmTentcompDTO && errors.iwwPortsLivePmTentcompDTO.remarks && touched.iwwPortsLivePmTentcompDTO && touched.iwwPortsLivePmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwPortsLivePmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {/* <Tab eventKey="perfomanceindicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsLivePmPiDTO" Name1="forecastTrainTraffic" Name2="actualTrainTraffic" Label1="Port traffic - forecasted" Label2="Port traffic - actual"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwPortsLivePmPiDTO.remarks" label="Remarks" name="iwwPortsLivePmPiDTO.remarks" disabled={status}/>
                            {errors.iwwPortsLivePmPiDTO && errors.iwwPortsLivePmPiDTO.remarks && touched.iwwPortsLivePmPiDTO && touched.iwwPortsLivePmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwPortsLivePmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab> */}
            <Tab eventKey="indicators" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsLivePmIndicatorsDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwPortsLivePmIndicatorsDTO.remarks" label="Remarks" name="iwwPortsLivePmIndicatorsDTO.remarks" disabled={status} />
                            {errors.iwwPortsLivePmIndicatorsDTO && errors.iwwPortsLivePmIndicatorsDTO.remarks && touched.iwwPortsLivePmIndicatorsDTO && touched.iwwPortsLivePmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwPortsLivePmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Other" title={
                <OverlayTrigger placement="bottom" overlay={otherTootltip}>
                    <div>Others</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_OTHER_IWWPP errors={errors} touched={touched} disabled={status} TypeForm="iwwPortsLiveOtherDTO" values={values} />
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}

export default TODIS_FORM_LIWWPORTS;